export default __webpack_public_path__ + "static/media/sg4.a80163fb.png";